import z from "zod";
import { BaseSchema } from "../common";

export const FeatureSchema = z.object({
  ...BaseSchema.shape,
  slug: z.string().min(1, "Slug is required"),
  nameEn: z.string().trim().min(3),
  nameAr: z.string().trim().min(3),
  nameTr: z.string().trim().min(3).catch("Name TR"),
  nameFa: z.string().trim().min(3).catch("Name FA"),
});
